module.exports = __webpack_public_path__ + "static/media/ziemia.5a694313.jpg";